(function(){
  // Delegation: on écoute les clics sur les cartes de variantes
  document.addEventListener('click', function(e){
    var card = e.target.closest('.js-variant-card');
    if(!card) return;

    // 1) Cocher la radio de la variante
    var radio = card.querySelector('input[type="radio"]');
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // 2) Sélectionner automatiquement un selling plan (si dispo)
    var planId = card.getAttribute('data-selling-plan-id');
    if (!planId) return; // pas de plan applicable pour cette variante

    // Cas 1 : radios (c_subscriptions rend souvent des radios)
    var planRadio = document.querySelector('variant-selector[data-type="selling_plan"] input[name="selling_plan"][value="'+ planId +'"]');
    if (planRadio) {
      if (!planRadio.checked) {
        planRadio.checked = true;
        planRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    // Cas 2 : select (fallback)
    var planSelect = document.querySelector('variant-selector[data-type="selling_plan"] select[name="selling_plan"]');
    if (planSelect) {
      if (planSelect.value !== String(planId)) {
        planSelect.value = String(planId);
        planSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    // Cas 3 : input hidden (rare)
    var planHidden = document.querySelector('variant-selector[data-type="selling_plan"] input[name="selling_plan"]');
    if (planHidden) {
      if (planHidden.value !== String(planId)) {
        planHidden.value = String(planId);
        planHidden.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
})();